<template>
  <div>
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>

        <div
          class="container-dz-top"
          style="padding: 10px 20px"
          v-if="currentUser.TYPE_USER !== 'declarer'"
        >
          <div class="row">
            <div class="col-md-6">
              <div class="col-md-12 mycol container-dz-top--text">
                Программа финансирования: «{{
                  getProgramName(project.UF_SUPPORT_PROG_ID)
                }}»
              </div>
              <template v-if="project.UF_SUM_APPROVED > 0">
                <div class="col-md-12 mycol container-dz-top--text">
                  Одобренная сумма - «{{ project.UF_SUM_APPROVED | format }}»
                  тыс. руб.
                </div>
              </template>
              <div class="col-md-12 mycol container-dz-top--text">
                Наименование проекта: «{{ project.UF_NAME }}»
              </div>
              <div class="form-group" style="display: block; ">
                <p style="font-weight: bold">
                  Менеджер сопровождения: {{ project.UF_MANAGER_OSP_NAME }}
                </p>
                <p
                  style="font-weight: bold"
                  v-if="project.UF_MANAGER_OSP > 0 && isSetEmailManagerOSP"
                >
                  <span
                    >Включить оповещения на почту Менеджера сопровождения</span
                  >
                  <span>
                    <label class="switch">
                      <input
                        type="checkbox"
                        v-model="project.UF_SETTING.IS_SEND_MAIL_MANAGER_OSP"
                        v-on:change="changeSendEmailStatusMNG_OSP()"
                      />
                      <span class="slider round"></span>
                    </label>
                  </span>
                </p>
                <ChangeManagerOSP v-if="showChangeManagerDialog" />
                <button
                  style="margin-bottom: 15px"
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  v-if="
                    isEdit && currentUser.ACTIVE_ROLE_CODE !== 'region_fond'
                  "
                  @click="handleChangeManagerDialog"
                >
                  <label
                    style="cursor: pointer"
                    v-if="project.UF_MANAGER_OSP > 0"
                  >
                    Изменить менеджера сопровождения
                  </label>
                  <label style="cursor: pointer" v-else>
                    Назначить менеджера сопровождения
                  </label>
                </button>
              </div>

              <div
                class="form-group"
                style="display: block;"
                v-if="
                  currentUser.ACTIVE_ROLE_CODE == 'admin' ||
                    currentUser.ACTIVE_ROLE_CODE == 'OMP_staff'
                "
              >
                <div class="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      :disabled="!isEdit"
                      v-model="project.UF_SETTING.IS_ECP_REQ_DZ"
                      @change="setIsEcPSZ"
                    />
                    <b>Загрузка документов с ЭЦП</b>
                  </label>
                </div>
              </div>

              <div class="form-group mycol controller-button">
                <div class="container-stl-title" style="padding: 0; max-width: 300px;">
                  <a
                    :href="getLinkRequestCreate()"
                    class="link-add-row"
                    title="Создать новый запрос"></a>
                  Внутренние согласования
                </div>

                <div class="container-stl-body" style="padding: 0;">
                  <div class="df-ac">
                    <a
                      :href="getLinkRequest()"
                      class="butt-blue butt-stl stl-mr-10"
                    >
                      {{
                        documentConf.PROJECT_NOTIFICATIONS.EVENT_AREA
                          .TEXT_BUTTON
                      }}</a
                    >

                    <span class="card-info-text">
                            <i class="icon-item icon-info-dis"></i>
                            {{
                        documentConf.PROJECT_NOTIFICATIONS.EVENT_AREA
                          .TEXT_AREA
                      }}
                          </span>
                  </div>
                </div>

              </div>

            </div>
            <div
              class="col-md-6"
              :style="
                project.UF_IS_PROJECT_REGIONAL_PROGRAMM == 1 &&
                currentUser.ACTIVE_ROLE_CODE !== 'region_fond'
                  ? 'min-height:260px;'
                  : ''
              "
            >
              <div class="form-horizontal">
                <div v-if="false" class="form-group">
                  <label
                    class="col-md-4 mycol control-label"
                    style="text-align: left"
                  >
                    Планируемая дата подписания договора
                  </label>
                  <div class="col-sm-3">
                    <datepicker
                      :disabled="isDisabledField"
                      v-model="project.UF_LOAN_UPDATE_PLAN"
                      :language="ru"
                      input-class="form-control"
                    />
                  </div>
                  <div class="pull-right">
                    <a
                      v-if="
                        currentUser.TYPE_USER !== 'declarer' &&
                          currentUser.ACTIVE_ROLE_CODE !== 'region_fond' &&
                          currentUser.ACTIVE_ROLE_CODE !== 'auditor'
                      "
                      target="_blank"
                      :href="
                        'http://rftr1500/ReportServer/Pages/ReportViewer.aspx?%2fОтчеты%2fДСП%2fСтатус+документов+чек-листа&application_number=' +
                          project.UF_NUMBER +
                          '&rs:Command=Render'
                      "
                      class="btn btn-success"
                      style="margin-right: 12px"
                    >
                      Отчёт по чек-листу
                    </a>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    class="col-md-4 mycol control-label"
                    style="text-align: left"
                  >
                    Фактическая дата подписания договора
                  </label>
                  <div class="col-sm-3">
                    <datepicker
                      :disabled="isDisabledField"
                      v-model="project.UF_LOAN_UPDATE"
                      :language="ru"
                      :monday-first="true"
                      input-class="form-control"
                      :class="!isDisabledField ? 'not-readonly-block' : ''"
                    />
                  </div>
                  <div class="pull-right">
                    <a
                      v-if="
                        currentUser.TYPE_USER !== 'declarer' &&
                          currentUser.ACTIVE_ROLE_CODE !== 'region_fond' &&
                          currentUser.ACTIVE_ROLE_CODE !== 'auditor'
                      "
                      target="_blank"
                      :href="
                        'http://rftr1500/ReportServer/Pages/ReportViewer.aspx?%2fОтчеты%2fДСП%2fСтатус+документов+чек-листа&application_number=' +
                          project.UF_NUMBER +
                          '&rs:Command=Render'
                      "
                      class="btn btn-success"
                      style="margin-right: 12px"
                    >
                      Отчёт по чек-листу
                    </a>
                  </div>
                </div>
                <div v-if="false" class="form-group">
                  <label
                    class="col-md-4 mycol control-label"
                    style="text-align: left"
                  >
                    Дата перечисления займа
                  </label>
                  <div class="col-sm-3">
                    <datepicker
                      :disabled="isDisabledField"
                      v-model="project.UF_LOAN_DATE_ZAIM"
                      :language="ru"
                      input-class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label
                    class="col-md-4 mycol control-label"
                    style="text-align: left"
                  >
                    Номер договора займа
                  </label>
                  <div class="col-sm-3">
                    <div class="input-group" style="justify-content: left;">
                      <span class="input-group-addon">ДЗ-</span>
                      <input
                        :disabled="isDisabledField"
                        v-model="zaimNumberFirst"
                        @input="onZaimNumberFirstInput"
                        placeholder="XXX"
                        v-mask="['###', '##', '#']"
                        :language="ru"
                        class="form-control"
                        style="width: 50px;"
                      />
                      <span
                        class="input-group-addon"
                        style="border-left: none; border-right: none; padding: 0 4px;"
                        >/</span
                      >
                      <input
                        :disabled="isDisabledField"
                        v-model="zaimNumberSecond"
                        v-mask="'##'"
                        @input="onZaimNumberSecondInput"
                        placeholder="XX"
                        :language="ru"
                        class="form-control"
                        style="width: 50px;"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="form-group mycol"
                  v-if="documentConf.isViewButtonChangeStatusDZ"
                >
                  <button
                    type="button"
                    :disabled="
                      !project.UF_NUMBER_ZAIM ||
                        !project.UF_LOAN_UPDATE ||
                        !zaimNumberFirst ||
                        !zaimNumberSecond
                    "
                    @click="openQuestionChangeStatus()"
                    class="btn btn-primary"
                  >
                    {{ documentConf.textButtonDZ }}
                  </button>
                </div>
                <div class="form-group mycol">
                  <button
                    class="btn btn-primary"
                    v-if="isViewDownloadFileDogovor"
                    @click="startDogovorDownload"
                  >
                    Загрузить файл договора
                  </button>
                </div>
                <div class="form-group mycol" v-show="false">
                  <div class="col-sm-10">
                    <label>Комментарий</label>
                    <textarea
                      :disabled="isDisabledField"
                      class="form-control"
                      maxlength="150"
                      v-model="project.UF_LOAN_COMMENT"
                    />
                  </div>
                </div>
                <div class="form-group mycol controller-button">
                  <p><span>Приложения к ДЗ:</span></p>
                  <a
                    type="button"
                    class="btn btn-primary"
                    @click="getPrintTZDocxUrl"
                    v-show="showBtnGetPrintTZDocxUrl() === true"
                  >
                    {{ getNameApplicationTZ() }}
                  </a>
                  &nbsp;
                  <a
                    type="button"
                    class="btn btn-primary"
                    @click="getPrintBudgetDocxUrl"
                    v-show="showBtnGetPrintBudgetDocxUrl() === true"
                  >
                    Смета расходования средств
                  </a>
                  &nbsp;
                  <a
                    type="button"
                    class="btn btn-primary"
                    @click="getPrintPlanDocxUrl"
                    v-show="showBtnGetPrintKPUrl() === true"
                  >
                    Календарный план Проекта
                  </a>
                  &nbsp;
                  <a
                    type="button"
                    class="btn btn-primary"
                    @click="getPrintIndicatorsDocxUrl"
                  >
                    Целевые показатели
                  </a>
                </div>

                <div class="form-group mycol" v-if="isViewSave">
                  <div class="col-md-4">
                    <button
                      type="button"
                      :disabled="
                        !project.UF_NUMBER_ZAIM ||
                          !project.UF_LOAN_UPDATE ||
                          !zaimNumberSecond ||
                          !zaimNumberFirst ||
                          project.IS_NOT_SAVE_DOGOVOR_DZ
                      "
                      @click="saveInfo()"
                      class="btn btn-default"
                    >
                      Сохранить
                    </button>
                  </div>
                </div>
                <template v-if="project.UF_IS_PROJECT_REGIONAL_PROGRAMM == 1">
                  <div class="form-group" style="display: block;">
                    <button
                      style="margin-bottom: 15px"
                      type="button"
                      class="btn btn-primary"
                      data-dismiss="modal"
                      v-if="isEdit && isSetManagerRFRP"
                      @click="handleChangeManagerRfrpDialog"
                    >
                      <label
                        style="cursor: pointer"
                        v-if="project.UF_MANAGER_RFRP > 0"
                        >Изменить менеджера РФРП</label
                      >
                      <label style="cursor: pointer" v-else
                        >Назначить менеджера РФРП</label
                      >
                    </button>

                    <p
                      style="font-weight: bold"
                      v-if="
                        project.UF_MANAGER_RFRP > 0 && isSetEmailManagerRFRP
                      "
                    >
                      <span>Включить оповещения на почту Менеджера РФРП</span>
                      <span>
                        <label class="switch">
                          <input
                            type="checkbox"
                            v-model="
                              project.UF_SETTING.IS_SEND_MAIL_MANAGER_RFRP
                            "
                            @change="changeSendEmailStatusMNG_RFRP()"
                          />
                          <span class="slider round"></span>
                        </label>
                      </span>
                    </p>

                    <p v-if="true" style="font-weight: bold">
                      Менеджер сопровождения РФРП:
                      {{ project.UF_MANAGER_RFRP_NAME }}
                    </p>
                    <ChangeManagerRFRP v-if="showChangeManagerRfrpDialog" />
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- row-->
        </div>
        <!-- container-dz-top -->

        <div v-if="documentConf.IS_SHOW_LIST">
          <div class="container-fluid mycontainer-fluid content">
            <ProgressDZ
              :document-conf="documentConf"
              :vid_doc="directory.sp_vid_doc_dz"
            />
            <div
              v-for="ltItem in documentConf.LIST_TYPE"
              :key="ltItem.SECTION_ID"
              v-if="ltItem.IS_VIEW_CURRENT_ACCOUNT == 1"
            >
              <a
                id="payment_account"
                v-if="ltItem.IS_VIEW_CURRENT_ACCOUNT_RS == 1"
                style="padding-top: 80px;"
              />
              <a v-else :id="ltItem.SECTION_CODE" style="padding-top: 80px;" />

              <div
                v-if="ltItem.IS_VIEW_BUTTON_TRANSHES === 1"
                class="content-title"
              >
                {{ ltItem.NUMBER }}. {{ ltItem.SECTION_NAME }}
                <div style="padding: 0 0 20px 20px;">
                  <a
                    type="button"
                    class="btn btn-primary"
                    :href="ltItem.TRANSH_URL"
                    target="_blank"
                  >
                    {{ ltItem.TRANSH_LINK_NAME }}
                  </a>
                </div>
              </div>

              <div
                v-else
                class="content-title"
                style="display: flex; align-items: center"
              >
                <template v-if="ltItem.IS_VIEW_CURRENT_ACCOUNT_RS != 1">
                  {{ ltItem.NUMBER }}.
                </template>
                {{ ltItem.SECTION_NAME }}
                <VDropdown
                  v-if="ltItem.SECTION_HELP"
                  tag="span"
                  trigger="click"
                  placement="bottom"
                  popperClass="custom-popper"
                  style="display: inline"
                >
                  <a class="icon-help-blue">
                    &nbsp;
                  </a>
                  <template #popper>
                    <div class="custom-popper-content">
                      {{ ltItem.SECTION_HELP }}
                    </div>
                  </template>
                </VDropdown>
                <i
                  class="i-edit centerIcon"
                  @click="
                    showEditTableDialog(
                      ltItem.RECORD_MODEL_ID,
                      ltItem.SECTION_NAME
                    )
                  "
                  v-if="ltItem.BLOCK_IS_EDIT_NAME && addBlocks"
                />
                <i
                  class="i-delete centerIcon"
                  @click="
                    deleteField(ltItem.RECORD_MODEL_ID, ltItem.SECTION_NAME)
                  "
                  v-if="ltItem.BLOCK_IS_EDIT_NAME && addBlocks"
                />
              </div>

              <div v-if="ltItem.IS_VIEW_CURRENT_ACCOUNT_RS == 1" class="row">
                <div class="current-reestr-dz">
                  <a
                    type="button"
                    class="btn btn-primary"
                    :href="ltItem.LINK_REESTR"
                    target="_blank"
                  >
                    {{ ltItem.LINK_REESTR_TEXT }}
                  </a>
                  <!--<a class="icon-help-blue" style="margin-top: 6px">
                    &nbsp;
                  </a>-->
                  <span style="padding-left: 45px;">
                    {{ ltItem.REESTR_INFO }}
                  </span>
                </div>

                <div class="current-reestr-dz">
                  <a
                    type="button"
                    class="btn btn-primary"
                    :href="ltItem.LINK_NEW_REQUEST"
                    style="min-width: 319px;"
                    target="_blank"
                  >
                    {{ ltItem.LINK_NEW_REQUEST_TEXT }}
                  </a>
                </div>
              </div>

              <div v-if="ltItem.CHILD">
                <MultiDocumentTableAddDZ
                  :project="project"
                  :index="ltItem.NUMBER"
                  :childs="ltItem.CHILD"
                  :docs="ltItem.TYPE_LIST_ID"
                  :document-conf="documentConf"
                  :document-history="documentHistory"
                />
              </div>
              <div v-else-if="ltItem.TYPE_LIST_ID">
                <DocumentTableAddDZ
                  :project="project"
                  :index="ltItem.NUMBER"
                  :docs="ltItem.TYPE_LIST_ID"
                  :document-conf="documentConf"
                  :document-history="documentHistory"
                />
              </div>
            </div>
            <div v-if="addBlocks">
              <BlocksDZ
                :project="project"
                :document-conf="documentConf"
                :document-history="documentHistory"
                :blocks="blocks"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <ChangeStatusDialog v-if="showChangeStatusDialog" />
    <div
      class="footer footer-fix"
      v-if="!isLoading && documentConf.IS_SHOW_LIST"
    >
      <div class="container-fluid mycontainer-fluid">
        <div class="footer-sabmit" v-show="!isLoading">
          <button
            v-if="currentUser.TYPE_USER === 'manager'"
            v-show="isChangeStatus"
            style="width: auto;"
            class="but-style but-push"
            v-on:click="showChangeStatusDialog = true"
          >
            Изменить статус
          </button>

          <button
            style="width: auto;"
            class="but-style but-download"
            @click="getLinkFileArhiveDZ"
            v-show="viewArchiveBtn"
          >
            Скачать одним архивом
          </button>

          <button
            style="width: auto;"
            class="but-style but-save"
            @click="getLinkGenerateLetterDZ"
            v-show="viewGenerateLetterBtn"
          >
            Сформировать письмо
          </button>

          <button
            style="width: auto;"
            class="but-style but-push"
            @click="getLinkGenerateRemainderDZ"
            v-show="viewGenerateRemainderBtn"
          >
            Сформировать напоминание
          </button>

          <div
            class="popover top"
            style="display: block; right:120px; bottom: 100px; left: auto; top: auto; cursor: pointer"
            v-if="documentConf.SHOW_SAVE_SESSION == 1"
            @click="documentConf.SHOW_SAVE_SESSION = 0"
          >
            <div class="arrow"></div>
            <h3 class="popover-title">Данные изменены</h3>
            <div class="popover-content">
              <p>Не забудьте сохранить их</p>
            </div>
          </div>

          <button
            style="width: auto; position: absolute; right:130px; color:blue; font-weight: bold;"
            class="but-style but-ext2"
            @click="setViewUserDZListDocuments"
            v-show="viewUserViewDocListBtn"
            :disabled="documentConf.IS_BLOCK_BUTTON_SET_VERSION === 1"
          >
            Отобразить заявителю
          </button>
        </div>

        <div class="myfooter">
          <div class="myfooter-frp"></div>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
    <div
      class="modal fade in"
      v-bind:class="{ show: showEditTable }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="showEditTable = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Редактирование блока</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Наименование блока</label>
              <input v-model="fieldName" class="form-control" />
            </div>

            <div v-if="loadType">
              <h5><b>Выбор документов</b>:</h5>
              <div class="form-group">
                <table
                  v-for="type in blockTypeInfo.ALL_TYPE"
                  class="tab-list-form"
                >
                  <tr class="padd4">
                    <td>
                      <input
                        type="checkbox"
                        v-model="listTypeSelect"
                        :id="type.ID"
                        :value="type.ID"
                      />
                    </td>
                    <td class="name" @click="addTempSection(type.ID)">
                      <span v-html="type.NAME"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="editField" type="button" class="btn btn-primary">
              Изменить
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="showEditTable = false"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Изменить статус -->
    <div
      class="modal fade in"
      tabindex="-1"
      v-bind:class="{ show: isViewDialogChangeStatus }"
      role="dialog"
    >
      <form>
        <div class="modal-dialog modal-new-style" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Статус заявки</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <p>
                  Вы уверены, что хотите изменить статус заявки на "{{
                    documentConf.textDialogDZ
                  }}"?
                </p>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                v-on:click="changeStatusYes()"
                class="butt-stl butt-green"
              >
                Да
              </button>

              <button
                type="button"
                class="butt-stl butt-red"
                data-dismiss="modal"
                v-on:click="changeStatusNo()"
              >
                Нет
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="content" v-if="isViewDownloadAreaFileDogovor">
      <div class="modal fade in show" tabindex="-1" role="dialog">
        <div class="window-doc" style="left: 35%">
          <h3 style="padding-bottom: 35px;" v-if="stepDogovorDownload == 3">
            Запустить процесс согласования?
          </h3>
          <h3 style="padding-bottom: 35px;" v-else>
            Загрузка файла договора займа
          </h3>
          <form
            action="#"
            @submit.prevent="submitDogovor"
            class="load-doc"
            style="padding-right: 20px"
          >
            <template v-if="stepDogovorDownload == 1">
              <div class="file-upload" style="margin-bottom: 20px;">
                <div class="file-upload-label">Файл:</div>
                <button type="button">Выберите файл</button>
                <div v-if="!fileDogovorName2" v-text="fileDogovorName"></div>
                <input
                  type="file"
                  :accept="acceptDogovor"
                  name="file"
                  ref="file"
                  @change="changeFileDogovor"
                />
              </div>
              <div class="row"><span v-text="fileDogovorName2"></span></div>
              <div v-if="errorText" class="alert alert-danger">
                {{ errorText }}
              </div>
              <div
                v-for="err in errorArr"
                class="alert alert-danger"
                style="margin-top: 10px"
              >
                {{ err.TEXT }}
              </div>
            </template>

            <template v-if="stepDogovorDownload == 2">
              <div class="file-upload" style="margin-bottom: 20px;">
                <div
                  class="file-upload-label"
                  style="width: auto; padding-right: 8px;font-weight: normal;"
                >
                  Файл:
                  <a
                    :href="documentConf.LIST_FILE_DZ.actual.UF_FILE_FULL"
                    target="_blank"
                    >{{ documentConf.LIST_FILE_DZ.actual.UF_FILE_NAME }}
                  </a>
                </div>
                <button
                  style="width:150px; float: right;"
                  type="button"
                  @click="changeFileDogovorByStep2"
                >
                  Изменить файл
                </button>
              </div>

              <div class="file-upload">
                <div>
                  Дата загрузки документа:
                  {{ documentConf.LIST_FILE_DZ.actual.UF_DATE_CREATE_STR }}
                </div>
              </div>

              <div class="file-upload" style="margin-bottom: 15px;">
                <div>
                  Загрузил:
                  {{ documentConf.LIST_FILE_DZ.actual.UF_CREATED_BY_STR }}
                </div>
              </div>

              <div
                v-if="documentConf.LIST_FILE_DZ.arhive.length > 0"
                class="file-upload"
                style="margin-bottom: 15px;"
              >
                <div>
                  Версия:
                  <a
                    href="javascript:void(0);"
                    @click="openViewHistoryVersionDZ"
                    >{{ documentConf.LIST_FILE_DZ.arhive.length }} (История)</a
                  >
                </div>
              </div>

              <div
                v-if="errorText"
                v-html="errorText"
                class="alert alert-danger"
              ></div>

              <div
                v-if="documentConf.LIST_FILE_DZ.actual.UF_SEND_MANAGER_ID > 0"
              >
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder stl-w-full window-doc-filter"
                >
                  <div class="file-upload-label" style="margin-bottom: 5px">
                    Дата отправки договора на согласование:
                    {{ documentConf.LIST_FILE_DZ.actual.UF_DATE_SEND_STR }}
                  </div>
                </div>

                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder stl-w-full window-doc-filter"
                >
                  <div class="file-upload-label" style="margin-bottom: 5px">
                    Кто отправил на согласование:
                    {{ documentConf.LIST_FILE_DZ.actual.UF_CREATED_BY_STR }}
                  </div>
                </div>
              </div>

              <div v-else>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder stl-w-full window-doc-filter"
                  style="margin-bottom: 15px;"
                >
                  <div class="file-upload-label" style="margin-bottom: 5px">
                    Дополнительные согласующие:
                  </div>
                  <Multiselect
                    label="LABEL"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    style="border: 1px solid transparent; padding: 0px"
                    :limit="10"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="addListConcordantsFormDogovor.UF_CONCORDANTS_ID"
                    :options="documentConf.DIRECTUM_LIST"
                    :multiple="true"
                    placeholder="Выбор согласующих"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder stl-w-full window-doc-filter"
                  style="margin-bottom: 15px;"
                >
                  <div class="file-upload-label" style="margin-bottom: 5px">
                    Подписант<sup style="color: red">*</sup>:
                  </div>
                  <Multiselect
                    label="LABEL"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    style="border: 1px solid transparent; padding: 0px"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="addListConcordantsFormDogovor.UF_SIGNATORY_ID"
                    :options="documentConf.DIRECTUM_LIST"
                    :multiple="false"
                    placeholder="Выбор подписанта"
                  />
                </div>
              </div>
            </template>

            <template v-if="stepDogovorDownload == 3">
              <div
                class="file-upload-label"
                style="margin: 0 auto; width: 500px;"
                v-if="showQuestion && errorArr.length == 0"
              >
                Вы уверены, что хотите отправить последнюю версию загруженного
                файла договора займа на согласование в Directum RX?
              </div>
              <div
                class="file-upload-label"
                style="margin: 0 auto; width: 500px;"
                v-if="showDonwloadProgress"
              >
                <p>
                  Идет отправка файла ДЗ в Директум
                  <img src="/img/waiting.gif" style="width:20px;" />
                </p>
              </div>

              <div
                v-for="err in errorArr"
                class="alert alert-danger"
                style="margin-top: 10px"
              >
                <div v-html="err.TEXT"></div>
              </div>
            </template>

            <div class="foot-butt center-block" style="text-align: center">
              <button
                v-if="
                  stepDogovorDownload == 1 &&
                    documentConf.LIST_FILE_DZ.actual &&
                    documentConf.LIST_FILE_DZ.actual.ID
                "
                type="button"
                class="b-o"
                style="height: 35px"
                @click="returnDogovorByStep2"
              >
                Отмена
              </button>
              <button
                v-else
                type="button"
                class="b-o"
                style="height: 35px"
                @click="isViewDownloadAreaFileDogovor = false"
              >
                Отмена
              </button>

              <button
                type="submit"
                class="b-l"
                style="height: 35px"
                v-if="fileDogovorName2 && stepDogovorDownload == 1"
                :disabled="!uploadBlockButton"
              >
                Загрузить
              </button>

              <button
                type="button"
                class="b-l"
                v-if="
                  stepDogovorDownload == 2 &&
                    documentConf.LIST_FILE_DZ.actual.UF_SEND_MANAGER_ID == 0
                "
                style="margin-left:80px; width: 300px; height: 35px"
                @click="setDogovorByStep3"
              >
                Отправить договор на согласование
              </button>

              <button
                type="button"
                class="b-l"
                v-if="stepDogovorDownload == 3 && showQuestion"
                style="margin-left:80px; width: 300px; height: 35px"
                @click="sendDogovorByDirect"
              >
                Отправить договор на согласование
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade in show"
      v-if="isViewHistoryVersionDZ"
      tabindex="-1"
      role="dialog"
    >
      <div
        style="width: 750px;z-index: 11000"
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="isViewHistoryVersionDZ = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">История загрузки договора займа</h4>
          </div>
          <div
            class="modal-body"
            style="
    overflow: scroll;
    max-height: 800px;
"
          >
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Версия документа</th>
                  <th>Документ</th>
                  <th>Дата загрузки документа</th>
                  <th>Кто загрузил</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in documentConf.LIST_FILE_DZ.arhive">
                  <td>{{ item.VERSION }}</td>
                  <td>
                    <a
                      :href="item.UF_FILE_FULL"
                      class="doc-link"
                      target="blank"
                      >{{ item.UF_FILE_NAME }}</a
                    >
                  </td>
                  <td>{{ item.UF_DATE_CREATE_STR }}</td>
                  <td>{{ item.UF_CREATED_BY_STR }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="isViewHistoryVersionDZ = false"
            >
              Закрыть
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  FETCH_PROJECT,
  FETCH_DIRECTORIES,
  SET_IS_VIEW_ALL_EXPERTISE
} from "@/store/actions.type";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import { ru } from "vuejs-datepicker/dist/locale";
import ChangeManagerOSP from "@/components/project/form/ChangeManagerOSP";
import ChangeManagerRFRP from "@/components/project/form/ChangeManagerRFRP";
import ProgressDZ from "@/components/project/form/partial/ProgressDZ";
import ChangeStatusDialog from "@/components/project/form/ChangeStatusDialog";
import MultiDocumentTable from "@/components/project/documents/MultiDocumentTable";
import MultiDocumentTableAddDZ from "@/components/project/documents/MultiDocumentTableAddDZ";
import DocumentTableAddDZ from "@/components/project/documents/DocumentTableAddDZ";
import BlocksDZ from "@/components/project/documents/BlocksDZ";
import { Dropdown as VDropdown } from "floating-vue";
import { mask } from "vue-the-mask";
import Multiselect from "vue-multiselect";

Vue.filter("fileName", function(value) {
  let l = value.split("/");

  return l[l.length - 1];
});

export default {
  name: "AddDZ",
  title: "Оформление договора займа",
  components: {
    Multiselect,
    BlocksDZ,
    ProjectMenu,
    ProjectHeader,
    Datepicker,
    ChangeManagerOSP,
    ChangeManagerRFRP,
    ProgressDZ,
    MultiDocumentTable,
    MultiDocumentTableAddDZ,
    ChangeStatusDialog,
    DocumentTableAddDZ,
    VDropdown
  },
  directives: {
    mask
  },
  data() {
    return {
      ru: ru,
      date: "",
      isEdit: false,
      isViewSave: false,
      isDisabledField: true,
      siteUrl: "",
      statuses: [],
      showEditTable: false,
      documentConf: {
        FILE_ACCEPT_INFO: {
          NEED_ACCEPT: 1,
          FACT_ACCEPT: 0,
          FACT_ACCEPT_YES: 0,
          FACT_ACCEPT_NO: 0
        },
        LIST_TYPE: [],
        FILE_DOCUMENTS_PATH: {},
        FILE_DOCUMENTS_SETTING: {},
        FILE_LIST_TYPE_ID: [],
        FILE_LOAD_INFO: { NEED_LOAD: 1, FACT_LOAD: 0 },
        SHOW_SAVE_SESSION: 0,
        IS_BLOCK_BUTTON_SET_VERSION: 1
      },
      showDocumentHistory: false,
      documentHistory: false,
      showCalendar: false,
      isChangeStatus: false,
      isChangeManager: false,
      showChangeStatusDialog: false,
      showChangeManagerDialog: false,
      showChangeManagerRfrpDialog: false,
      isSetEmailManagerOSP: false,
      isSetEmailManagerRFRP: false,
      viewArchiveBtn: false,
      isSetManagerRFRP: false,
      viewGenerateLetterBtn: false,
      viewGenerateRemainderBtn: false,
      viewUserViewDocListBtn: false,
      addBlocks: false,
      fieldName: "",
      fieldId: 0,
      blockTypeInfo: [],
      listTypeSelect: [],
      loadType: false,
      blocks: [],
      isViewDialogChangeStatus: false,
      number: 0,
      //isLoadingDZ: false,
      zaimNumberFirst: "",
      zaimNumberSecond: "",
      isViewDownloadFileDogovor: false,
      isViewDownloadAreaFileDogovor: false,
      fileDogovorName: "Файл не выбран",
      fileDogovorName2: "",
      acceptDogovor: "",
      errorArr: [],
      addDocFormDogovor: {
        FILE_NAME: "",
        FILE: ""
      },
      addListConcordantsFormDogovor: {
        UF_CONCORDANTS_ID: [],
        UF_SIGNATORY_ID: ""
      },
      errorText: "",
      stepDogovorDownload: 1,
      uploadBlockButton: true,
      isViewHistoryVersionDZ: false,
      showQuestion: false,
      showDonwloadProgress: false,
      firstDataLoad: true
    };
  },
  computed: {
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "calendarItems",
      "notifications",
      "isProjectLoading"
    ]),
    zaimNumber: {
      get() {
        return this.project.UF_NUMBER_ZAIM
          ? this.project.UF_NUMBER_ZAIM.slice(3)
          : "";
      },
      set(value) {
        this.project.UF_NUMBER_ZAIM = `ДЗ-${value}`;
      }
    }
  },
  watch: {
    zaimNumberFirst() {
      this.updateZaimNumber();
    },
    zaimNumberSecond() {
      this.updateZaimNumber();
    }
  },

  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await this.fetchData();

    if (this.project.UF_NUMBER_ZAIM) {
      const zaimNumberParts = this.project.UF_NUMBER_ZAIM.slice(3).split("/");
      this.zaimNumberFirst = zaimNumberParts[0] || "";
      this.zaimNumberSecond = zaimNumberParts[1] || "";
    }
  },
  methods: {
    updateZaimNumber() {
      this.zaimNumber = `${this.zaimNumberFirst}/${this.zaimNumberSecond}`;
    },
    onZaimNumberFirstInput(event) {
      const input = event.target.value;
      const regex = /^\d{0,3}$/;
      if (!regex.test(input)) {
        event.target.value = input.slice(0, -1);
      }
    },
    onZaimNumberSecondInput(event) {
      const input = event.target.value;
      const regex = /^\d{0,2}$/;
      if (!regex.test(input)) {
        event.target.value = input.slice(0, -1);
      }
    },

    async fetchDirectories() {
      await this.$store.dispatch(FETCH_DIRECTORIES, [
        "status",
        "status_all",
        "sp_vid_doc_dz",
        "tree/sp_type_doc_dz",
        "hl/dz_accept_electronic_view",
        "hl/dz_accept_paper_view",
        "hl/request_type",
        "program_fin_support"
      ]);
    },

    getLinkRequestCreate() {
      let string =
        '/requests?action=create&idProject=' + this.$route.params.id;
      return string;
    },

    getLinkRequest() {
      let string =
        '/requests?filter=' + JSON.stringify({
          project_number: this.project.UF_NUMBER,
          number:[],
          status: [],
          initiator: [],
          organization: [],
          performer: ""
        });
      return string;
    },

    async fetchProject() {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);

      const managerRoleDefaultSetting = await ProjectsService.getManagerRoleDefaultSetting();
      await this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        managerRoleDefaultSetting.data.IS_VIEW_ALL_EXPERTISE
      );
      this.isSetManagerRFRP =
        managerRoleDefaultSetting.data.IS_SET_MANAGER_RFRP === 1;
      this.isSetEmailManagerOSP =
        managerRoleDefaultSetting.data.IS_SET_MNG_OSP_STATUS_EMAIL === 1;
      this.isSetEmailManagerRFRP =
        managerRoleDefaultSetting.data.IS_SET_MNG_RFRP_STATUS_EMAIL === 1;

      const rulesChangeStatusUser = await ProjectsService.getRulesChangeStatusUser(
        this.project.UF_STATUS_ID
      );
      this.isEdit = rulesChangeStatusUser.data.IS_EDIT_DOGOVOR_ZAIMA;

      if (this.isEdit) {
        this.isViewSave =
          this.currentUser.ACTIVE_ROLE_CODE !== "OMP_staff" &&
          this.currentUser.ACTIVE_ROLE_CODE !== "admin";
        this.isDisabledField =
          !this.documentConf.isViewButtonChangeStatusDZ ||
          this.documentConf.modeDZ === "Funded";
      }

      /* this.isViewDownloadFileDogovor =
        this.currentUser.ACTIVE_ROLE_CODE == "OMP_staff" ||
        this.currentUser.ACTIVE_ROLE_CODE == "admin"
          ? true
          : false;*/

      this.viewArchiveBtn = rulesChangeStatusUser.data.IS_DOWNLOAD_DZ_ALL;
      this.viewGenerateLetterBtn =
        rulesChangeStatusUser.data.IS_GENERATE_LETTER;
      this.viewGenerateRemainderBtn =
        rulesChangeStatusUser.data.IS_GENERATE_REMINDER;
      this.viewUserViewDocListBtn =
        rulesChangeStatusUser.data.IS_SET_DZ_VIEW_BY_USER;
      this.addBlocks = rulesChangeStatusUser.data.IS_ADD_DZ_BLOCK;

      if (
        rulesChangeStatusUser.data.IS_CHANGE_STATUS &&
        this.currentUser.ACTIVE_ROLE_CODE === "OMP_staff"
      ) {
        const programFinSupport = this.directory.program_fin_support.find(
          s => s.ID === this.project.UF_SUPPORT_PROG_ID
        );
        if (programFinSupport) {
          const bpStatus = await ProjectsService.bpStatus(
            programFinSupport.UF_BP_ID,
            this.project.UF_STATUS_ID
          );
          this.statuses = this.getStatusesFromBpStatus(bpStatus.data);
          this.isChangeStatus =
            this.currentUser.ACTIVE_ROLE_CODE !== "OMP_staff" &&
            this.statuses.length > 0;
        }
      }
    },

    getStatusesFromBpStatus(bpStatusData) {
      const statuses = [];
      const prevStatusIds = Object.values(bpStatusData[0].PREV_STATUS_ID);
      const nextStatusIds = Object.values(bpStatusData[0].NEXT_STATUS_ID);

      prevStatusIds.forEach(statusId => {
        const status = this.directory.status.find(item => item.ID === statusId);
        if (status) statuses.push(status);
      });

      nextStatusIds.forEach(statusId => {
        const status = this.directory.status.find(item => item.ID === statusId);
        if (status) statuses.push(status);
      });

      return statuses;
    },

    async loadBlocks() {
      await ProjectsService.getBlockDocumentDZ(this.$route.params.id).then(
        async ({ data }) => {
          this.blocks = await data;
        },
        this
      );
    },

    async fetchData() {
      //this.isLoadingDZ = true;

      try {
        await this.clearSessionUser();

        const { data } = await ProjectsService.getDocumentDZProjects(
          this.$route.params.id
        );
        this.documentConf = data;

        await Promise.all([
          this.fetchDirectories(),
          this.fetchProject(),
          this.loadBlocks()
        ]);

        if (this.firstDataLoad) {
          let hashUrl = location.hash;
          if (hashUrl != "") {
            window.location.href = hashUrl;
          }
          this.firstDataLoad = false;
        }
      } catch (error) {
        console.error("Ошибка при загрузке данных в fetchData:", error);
      } finally {
        console.log("Ошибка при загрузке данных в fetchData:");
        //this.isLoadingDZ = false;
      }
    },

    clearSessionUser() {
      ProjectsService.clearSessionDocumentDZForUser(
        this.$route.params.id
      ).then(() => {}, this);
    },

    showEditTableDialog(id, name) {
      console.log("id =" + id + " name= " + name);
      this.fieldId = id;
      this.fieldName = name;
      this.loadType = false;
      this.getBlocksTypeList();
      this.showEditTable = true;
    },

    getBlocksTypeList() {
      ProjectsService.getBlockTypeDocDocumentDZ(
        this.$route.params.id,
        this.fieldId
      ).then(async ({ data }) => {
        this.blockTypeInfo = data;
        this.listTypeSelect = this.blockTypeInfo.UF_TYPE_DOC_DZ_ID;
        this.loadType = true;
        this.showEditTable = true;
      }, this);
    },

    addTempSection(id) {
      if (this.listTypeSelect) {
        if (this.listTypeSelect.indexOf(id) != -1) {
          this.listTypeSelect = this.listTypeSelect.filter(function(f) {
            return f !== id;
          });
        } else {
          this.listTypeSelect.push(id);
        }
      }
    },

    editField() {
      ProjectsService.editBlockDocumentDZ(this.project.ID, this.fieldId, {
        UF_NAME: this.fieldName,
        UF_TYPE_DOC_DZ_ID: this.listTypeSelect
      }).then(({ data }) => {
        if (!data.error) {
          this.showEditTable = false;
          this.updateDocInfo();
        }
      }, this);
    },

    deleteField(id) {
      if (confirm("Вы действительно хотите удалить блок?")) {
        ProjectsService.deleteBlockDocumentDZ(this.project.ID, id).then(
          ({ data }) => {
            if (!data.error) {
              this.updateDocInfo();
              this.loadBlocks();
              this.$toasted.show("Блок успешно удален", {
                theme: "green",
                position: "bottom-right",
                duration: 3500
              });
            } else {
              data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
            }
          },
          this
        );
      }
    },

    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },

    getLinkFileArhiveDZ() {
      ProjectsService.getLinkFileArhiveDZ(this.project.ID).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },

    getLinkGenerateLetterDZ() {
      ProjectsService.getLinkGenerateLetterDZ(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },

    getLinkGenerateRemainderDZ() {
      ProjectsService.getLinkGenerateRemainderDZ(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },

    setViewUserDZListDocuments() {
      if (
        confirm("Вы действительно хотите отобразить документы ДЗ Заявителю?")
      ) {
        ProjectsService.setViewDocumentDZForUser(this.project.ID).then(
          ({ data }) => {
            if (data.error) {
              data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
              return;
            } else {
              this.documentConf.IS_BLOCK_BUTTON_VIEW = 1;
              this.$toasted.show("Документы ДЗ доступны для пользователя", {
                theme: "green",
                position: "bottom-right",
                duration: 3000
              });
              this.documentConf.SHOW_SAVE_SESSION = 0;
              //this.viewUserViewDocListBtn = false;

              this.updateDocInfo();
            }
          }
        );
      }
    },

    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },

    handleChangeManagerDialog() {
      this.showChangeManagerDialog = !this.showChangeManagerDialog;
    },

    handleChangeManagerRfrpDialog() {
      this.showChangeManagerRfrpDialog = !this.showChangeManagerRfrpDialog;
    },

    saveInfo() {
      ProjectsService.saveDogovorZaimInfoProject(this.$route.params.id, {
        UF_LOAN_UPDATE_PLAN: this.project.UF_LOAN_UPDATE_PLAN,
        UF_LOAN_UPDATE: this.project.UF_LOAN_UPDATE,
        UF_LOAN_DATE_ZAIM: this.project.UF_LOAN_DATE_ZAIM,
        UF_NUMBER_ZAIM: this.project.UF_NUMBER_ZAIM,
        UF_LOAN_COMMENT: this.project.UF_LOAN_COMMENT
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show("Данные сохранены", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          this.fetchProject();
          this.isDisabledField = true;
          this.documentConf.modeDZ = "Funded";
        }
      }, this);
    },

    getPrintTZDocxUrl() {
      ProjectsService.getPrintTZDocxUrl(this.project.ID).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },

    getPrintBudgetDocxUrl() {
      ProjectsService.getPrintBudgetDocxUrl(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },

    getPrintPlanDocxUrl() {
      ProjectsService.getPrintPlanDocxUrl(this.project.ID).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },

    getPrintIndicatorsDocxUrl() {
      ProjectsService.getPrintIndicatorsDocxUrl(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },

    getProgramCode() {
      let t = this.directory.program_fin_support.filter(
        c => c.ID === this.project.UF_SUPPORT_PROG_ID
      );
      if (t.length > 0) {
        return t[0].CODE;
      }
      return "";
    },

    getProgramName(id) {
      let t = this.directory.program_fin_support.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
    },

    showBtnGetPrintTZDocxUrl() {
      return true;
    },

    getNameApplicationTZ() {
      let nameApplicationTZ = "Техническое задание";
      if (this.getProgramCode() === "lizing") {
        nameApplicationTZ = "Спецификация на промышленное оборудование";
      } else if (this.getProgramCode() === "component_and_resource_base") {
        nameApplicationTZ = "Основные характеристики проекта";
      }

      return nameApplicationTZ;
    },

    showBtnGetPrintBudgetDocxUrl() {
      if (
        this.getProgramCode() === "evolution" ||
        this.getProgramCode() === "regfond" ||
        this.getProgramCode() === "complectyushie" ||
        this.getProgramCode() === "complectyushie_rfrp" ||
        this.getProgramCode() === "epidemiological_control" ||
        this.getProgramCode() === "konversia" ||
        this.getProgramCode() === "working" ||
        this.getProgramCode() === "working_rfrp" ||
        this.getProgramCode() === "cifrovizaciya" ||
        this.getProgramCode() === "lekarstva" ||
        this.getProgramCode() === "stankostroi" ||
        this.getProgramCode() === "priority_program" ||
        this.getProgramCode() === "forestry_projects_rfrp" ||
        this.getProgramCode() === "component_and_resource_base" ||
        this.getProgramCode() === "improving_ecology" ||
        this.getProgramCode() === "transport_engineering" ||
        this.getProgramCode() === "auto_components" ||
        this.getProgramCode() === "providing_mobilization_needs"
      ) {
        return true;
      }
    },

    showBtnGetPrintKPUrl() {
      return !(
        this.getProgramCode() === "epidemiological_control" ||
        this.getProgramCode() === "component_and_resource_base" ||
        this.getProgramCode() === "providing_mobilization_needs"
      );
    },

    updateDocInfo() {
      ProjectsService.getDocumentDZProjects(this.$route.params.id).then(
        ({ data }) => {
          this.documentConf.FILE_LOAD_INFO = data.FILE_LOAD_INFO;
          this.documentConf.FILE_ACCEPT_INFO = data.FILE_ACCEPT_INFO;
          this.documentConf.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH;
          this.documentConf.LIST_TYPE = data.LIST_TYPE;
          this.documentConf.SHOW_SAVE_SESSION = data.SHOW_SAVE_SESSION;
          this.documentConf.IS_BLOCK_BUTTON_SET_VERSION =
            data.IS_BLOCK_BUTTON_SET_VERSION;
          this.documentConf.LIST_FILE_DZ = data.LIST_FILE_DZ;
          this.documentConf.DIRECTUM_LIST = data.DIRECTUM_LIST;
        },
        this
      );
    },

    changeSendEmailStatusMNG_OSP() {
      ProjectsService.setStatusEmailSendManagerOSPProject(this.project.ID, {
        IS_SEND_MAIL_MANAGER_OSP: this.project.UF_SETTING
          .IS_SEND_MAIL_MANAGER_OSP
          ? 1
          : 0
      }).then(response => {
        if (response.data.error === false) {
          let textMessage = this.project.UF_SETTING.IS_SEND_MAIL_MANAGER_OSP
            ? "Отправка оповещений на почту Менеджера сопровождения включена"
            : "Отправка оповещений на почту Менеджера сопровождения выключена";
          this.$toasted.show(textMessage, {
            theme: "green",
            position: "bottom-right",
            duration: 5000
          });
        } else {
          response.data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },

    changeSendEmailStatusMNG_RFRP() {
      ProjectsService.setStatusEmailSendManagerRFRPProject(this.project.ID, {
        IS_SEND_MAIL_MANAGER_RFRP: this.project.UF_SETTING
          .IS_SEND_MAIL_MANAGER_RFRP
          ? 1
          : 0
      }).then(response => {
        if (response.data.error === false) {
          let textMessage = this.project.UF_SETTING.IS_SEND_MAIL_MANAGER_RFRP
            ? "Отправка оповещений на почту Менеджера сопровождения РФРП включена"
            : "Отправка оповещений на почту Менеджера сопровождения РФРП выключена";
          this.$toasted.show(textMessage, {
            theme: "green",
            position: "bottom-right",
            duration: 5000
          });
        } else {
          response.data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },

    openQuestionChangeStatus() {
      this.isViewDialogChangeStatus = true;
    },

    changeStatusYes() {
      if (this.documentConf.modeDZ == "Signed") {
        //сохранение реквизитов Договора, если
        this.saveInfo();
      }

      ProjectsService.setNewStatusProjectByOmpStaff(this.project.ID, {
        UF_STATUS_ID: this.documentConf.statusNewID
      }).then(response => {
        if (response.data.errorArr.length) {
          response.data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        } else {
          this.$toasted.show("Статус проекта успешно изменен", {
            theme: "green",
            position: "bottom-right",
            duration: 5000
          });
          this.isViewDialogChangeStatus = false;
          this.fetchProject();
        }
      }, this);

      this.isViewDialogChangeStatus = false;
    },

    changeStatusNo() {
      if (this.documentConf.modeDZ == "Signed") {
        //статус не меняем, но удаляем реквизиты ДЗ (номер ДЗ и дату подписания)
        ProjectsService.clearAttributeDZProjectByOmpStaff(this.project.ID).then(
          response => {
            if (response.data.errorArr.length) {
              response.data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
            } else {
              this.$toasted.show("Реквизиты ДЗ удалены", {
                theme: "green",
                position: "bottom-right",
                duration: 5000
              });
              this.isViewDialogChangeStatus = false;
              this.fetchProject();
            }
          },
          this
        );
      }

      this.isViewDialogChangeStatus = false;
    },

    startDogovorDownload() {
      this.isViewDownloadAreaFileDogovor = true;
      this.fileDogovorName2 = "";
      this.addDocFormDogovor.FILE = "";
      this.addDocFormDogovor.FILE_NAME = "";
      this.typeIndex = -1;
      this.uploadBlockButton = true;
      this.errorText = "";

      //проверяем наличие загруженной версии
      if (
        this.documentConf.LIST_FILE_DZ &&
        this.documentConf.LIST_FILE_DZ.actual &&
        this.documentConf.LIST_FILE_DZ.actual.ID > 0
      ) {
        this.stepDogovorDownload = 2;
      } else {
        this.stepDogovorDownload = 1;
      }

      console.log(this.stepDogovorDownload);
    },

    changeFileDogovor(e) {
      let files = e.target.files;
      if (files.length > 0) {
        let file = files[0];

        if (file.size < 1024 * 1024 * 100) {
          this.fileDogovorName2 = file.name;
          this.addDocFormDogovor.FILE = file;
          this.addDocFormDogovor.FILE_NAME = this.fileName;
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      }
    },
    changeFileDogovorByStep2() {
      this.stepDogovorDownload = 1;
      this.addDocFormDogovor.FILE = "";
      this.addDocFormDogovor.FILE_NAME = "";
      this.fileDogovorName2 = "";
      this.errorText = "";
      this.errorArr = [];
      this.addListConcordantsFormDogovor.UF_CONCORDANTS_ID = [];
      this.addListConcordantsFormDogovor.UF_SIGNATORY_ID = 0;
      this.uploadBlockButton = true;
    },
    returnDogovorByStep2() {
      this.stepDogovorDownload = 2;
    },
    setDogovorByStep3() {
      this.errorText = "";
      if (this.addListConcordantsFormDogovor.UF_SIGNATORY_ID == 0) {
        this.errorText = "Необходимо указать подписанта договора займа<br/>";
      }

      /*if (this.addListConcordantsFormDogovor.UF_CONCORDANTS_ID.length == 0) {
        this.errorText +=
          "Необходимо указать согласующих при подписании договора займа";
      }*/

      if (this.errorText == "") {
        this.stepDogovorDownload = 3;
        this.showQuestion = true;
        this.showDonwloadProgress = false;
      }
    },
    sendDogovorByDirect() {
      this.showDonwloadProgress = true;
      this.showQuestion = false;
      this.errorArr = [];

      ProjectsService.sendDogovorZaimDZByDirectum(
        this.documentConf.LIST_FILE_DZ.actual.ID,
        this.addListConcordantsFormDogovor
      ).then(response => {
        if (!response.data.error) {
          this.updateDocInfo();

          let textCreateDogovor = "Документ успешно отправлен в Директум.";
          if (response.data.taskId > 0) {
            textCreateDogovor +=
              " Создана задача на согласование по регламенту.";
            if (
              response.data.startTaskCode == 200 ||
              response.data.startTaskCode == 204
            ) {
              textCreateDogovor += " Задача успешно запущена.";
            }
          }

          this.$toasted.show(textCreateDogovor, {
            theme: "green",
            position: "bottom-right",
            duration: 5000
          });

          if (response.data.taskError.length > 0) {
            this.errorArr = response.data.taskError;

            this.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);

            this.showQuestion = true;
            this.showDonwloadProgress = false;
            this.uploadBlockButton = true;
          } else {
            setTimeout(this.setDogovorByStep2, 3000);
            this.errorArr = [];
          }
        } else {
          this.errorArr = response.data.errorArr;

          this.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);

          this.showQuestion = true;
          this.showDonwloadProgress = false;

          this.uploadBlockButton = true;
        }
      }, this);
    },
    submitDogovor() {
      this.uploadBlockButton = false; //блокировка кнопки
      let formData = new FormData();
      if (this.addDocFormDogovor.FILE) {
        formData.append("FILE", this.addDocFormDogovor.FILE);
        formData.append("FILE_NAME", this.addDocFormDogovor.FILE_NAME);
      }
      ProjectsService.saveDogovorZaimDZ(
        this.project.ID,
        formData,
        this.fileForm
      ).then(response => {
        if (!response.data.error) {
          this.updateDocInfo();
          this.$toasted.show("Документ успешно загружен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
          setTimeout(this.setDogovorByStep2, 2000);
        } else {
          this.errorArr = response.data.errorArr;
          this.uploadBlockButton = true;
        }
      }, this);
      return false;
    },
    setDogovorByStep2() {
      this.stepDogovorDownload = 2;
    },
    openViewHistoryVersionDZ() {
      this.isViewHistoryVersionDZ = true;
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    setIsEcPSZ() {
      this.project.UF_SETTING.IS_ECP_REQ_DZ =
        this.project.UF_SETTING && this.project.UF_SETTING.IS_ECP_REQ_DZ
          ? 1
          : 0;

      ProjectsService.editUfSettingProject(this.project.ID, "IS_ECP_REQ_DZ", {
        VALUE: this.project.UF_SETTING.IS_ECP_REQ_DZ
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show(
            'Настройка поля "Загрузка документов с ЭЦП" успешно изменена',
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );

          this.updateDocInfo();
        }
      }, this);
    }
  },
  filters: {
    format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1 ")
  }
};
</script>

<style>
.input-group {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
